import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { MANAGER, TEAM_LEADER, EMPLOYEE, PROJECT_SPONSOR } from '../../store/actions/users/usersActions';
import { Cache } from 'aws-amplify';

import ProjectMonitoring from './ProjectMonitoring';
import TimesheetCalendar from './TimesheetCalendar';
//import SubordinatesMonitoring from './SubordinatesMonitoring';
import TimesheetApprovals from '../timesheet/TimesheetApprovals';
import BudgetedHoursRequests from './BudgetedHoursRequests';

class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.roleId = '';
  }

  displayProjectMonitoring = () => {  
    if (this.roleId === MANAGER || this.roleId === PROJECT_SPONSOR) {
      return (
        <>
          <Row>
            <Col>
              <h6>Project Run Rate</h6>
            </Col>
          </Row>
          <Row>
            <Col>
              <ProjectMonitoring />
            </Col>
          </Row>
        </>
      )
    }
    
    return '';
    //<Approvals  inDashboard="yes" />
  }

  displayBudgetRequests = () => {
    if (this.roleId === MANAGER) {
      return (
        <>
          <Row>
            <Col>
              <h6>Request for Additional Budget </h6>
            </Col>
          </Row>
          <Row>
            <Col>
              <BudgetedHoursRequests />
            </Col>
          </Row>
        </>
      )
    }
  }

  displaySubordinatesMonitoring = () => {
    if (this.roleId === TEAM_LEADER) {
      return (
        <>
          <Row className="mt-3">
            <Col>
              <h6>Timesheet Approvals</h6>
            </Col>
          </Row>
          <Row>
            <Col>
              <TimesheetApprovals inDashboard="yes" />
            </Col>
          </Row>
        </>
      )
    }

    return '';
    //<SubordinatesMonitoring />
  }

  displayTimesheetCalender = () => {
    if (this.roleId === EMPLOYEE) {
      return (
        <TimesheetCalendar />
      )
    }

    return '';
  }

  render() {
    this.roleId = Cache.getItem('roleId');
    return (
      <div>
        <h5>Dashboard</h5>
        <Row className="mt-3 dashboard-widgets">
          <Col>
            { this.displaySubordinatesMonitoring() }
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            { this.displayTimesheetCalender() }
          </Col>
        </Row>
        <Row className="mt-3 dashboard-widgets">
          <Col>
            { this.displayProjectMonitoring() }
          </Col>
        </Row>
        <Row className="mt-3 dashboard-widgets">
          <Col>
            { this.displayBudgetRequests() }
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
})

export default connect(mapStateToProps)(Dashboard)
